import { getContext, Symbols } from 'choerodon-ui/shared';
export const TreeContext = getContext(Symbols.TreeContext, {});
